import { render, staticRenderFns } from "./Page1CFresh.vue?vue&type=template&id=e4e438da&scoped=true&"
import script from "./Page1CFresh.vue?vue&type=script&lang=js&"
export * from "./Page1CFresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e438da",
  null
  
)

export default component.exports